import React, { memo } from 'react';
import { sprintf } from 'sprintf';

import { Spinner } from 'components/Spinner';

type Props = {
  filter: string;
  isFetching: boolean;
  resultCount?: number;
};

const HEIGHT = 27;

export const ContentTip: React.FunctionComponent<Props> = memo(
  ({ filter, isFetching, resultCount }) => {
    if (filter.length === 0) {
      return (
        <div style={{ minHeight: HEIGHT, fontSize: '12px' }} className='key-value key-value--vault'>
          Suggested artworks
        </div>
      );
    }

    const hasNotEnoughChars = filter.length > 0 && filter.length < 3;
    const hasEnoughChars = filter.length >= 3;

    return (
      <div
        style={{ minHeight: HEIGHT, fontSize: '12px' }}
        className='key-value--color-subtle text-center lh-1'
      >
        {hasEnoughChars && isFetching && (
          <span className='pos-abs translate-to-left-100 pr-mini' style={{ marginTop: '-2px' }}>
            <Spinner className='square-spin--light square-spin--xs' />
          </span>
        )}
        {hasNotEnoughChars
          ? sprintf('Type %s more characters to search', 3 - filter.length)
          : isFetching
          ? 'Searching for artworks'
          : resultCount === 0
          ? sprintf('Nothing found for ‘%s’', filter)
          : sprintf('Results for ‘%s’', filter)}
      </div>
    );
  },
);
